var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('UserHelp'),_c('v-row',{attrs:{"dense":""}},[_c('v-col',[_c('UserList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }